import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../Reception/Style.css';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  state = {
    isOffline: false,
    isInquiries: false,
  };

  render() {
    return (
      <React.Fragment>
        <span className={`ml-auto ${this.props.class}`} ><a>Miracle Dome</a> &copy; 2024</span>
        <span className="ml-auto" style={{fontSize:'13px'}}>Solution partner <a target="_blank" href={"https://business.dialog.lk/"} style={{textDecoration:'none',color:'#1f1f1f!important'}}>Dialog Enterprise</a></span>
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
